import { COUNTRIES } from '@constants/countries';
import { BookingFormField } from '@domain/booking-form-field';
import { TicketHolderFormField } from '@domain/ticket-holder-form-field';

import { AddGuestBody } from './add-holder-modal.type';

const trimedCountry = (countryName: string) => {
  // TODO: Handle countries by slug https://xceeddev.atlassian.net/browse/XCEED-5273
  const cutFromIdx: number = countryName.lastIndexOf('(');
  return cutFromIdx === -1 ? countryName : countryName.substring(0, cutFromIdx - 1);
};

const mapDefaultValues = (slug: string, isoCode: string) => {
  if (slug === 'nationality') return isoCode;
  if (slug === 'phone') return COUNTRIES[isoCode].dialCode;
  if (slug === 'gender') return 'not-to-say';
  return '';
};

const formattedDate = (date: string) => {
  return date.split('/').reverse().join('-');
};

const formatFieldValue = (key: string, value: string): string => {
  switch (key) {
    case 'phone':
      return value.replaceAll(' ', '');
    case 'country':
      return trimedCountry(value);
    case 'birth':
      return formattedDate(value);
    default:
      return value;
  }
};

const formatFormFields = (data: { [x: string]: string }) => {
  return Object.entries(data).map(([key, value]) => ({
    name: key,
    value: formatFieldValue(key, value),
  }));
};

export const ensureEmailField = (
  ticketHolderFields: TicketHolderFormField[],
  bookingFields: BookingFormField[]
): TicketHolderFormField[] => {
  if (ticketHolderFields.some((field) => field.slug === 'email')) return ticketHolderFields;

  const emailField = bookingFields.find((field) => field.slug === 'email');
  if (!emailField) return ticketHolderFields;

  const lastNameIndex = ticketHolderFields.findIndex((field) => field.slug === 'lastName');
  const insertIndex = lastNameIndex >= 0 ? lastNameIndex + 1 : ticketHolderFields.length;

  return [...ticketHolderFields.slice(0, insertIndex), emailField, ...ticketHolderFields.slice(insertIndex)];
};

export const createDefaultValues = (fields: TicketHolderFormField[], isoCode: string, defaultChannelId?: string) =>
  fields.reduce<{ [x: string]: string | undefined }>(
    (acc, field) => {
      acc[field.slug] = mapDefaultValues(field.slug, isoCode);
      return acc;
    },
    {
      channelId: defaultChannelId,
    }
  );

export const mapDataToBackend = (data: Record<string, string>, passId: string): AddGuestBody => {
  const { channelId, firstName, lastName, email, ...rest } = data;
  return {
    offerId: passId,
    channelId,
    bookingFormFields: formatFormFields({ firstName, lastName, email }),
    ticketHolderFormFields: [formatFormFields({ firstName, lastName, email, ...rest })],
    numTickets: 1,
  };
};
